import type * as Types from 'app/types/graphql';

import {
  PlatformProductSelectFragmentDoc,
  PlatformProductVariantSelectFragmentDoc,
} from '../fragments/platformProduct.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PlatformProductQueryVariables = Types.Exact<{
  baseID: Types.Scalars['String']['input'];
  platform: Types.Platform;
}>;

export type PlatformProductQueryResponse = {
  platformProduct: Pick<
    Types.PlatformProduct,
    | 'id'
    | 'baseID'
    | 'handle'
    | 'title'
    | 'image'
    | 'status'
    | 'onlineStoreURL'
    | 'publishedAt'
    | 'templateSuffix'
  > & {
    variants?: Types.Maybe<
      Array<Pick<Types.PlatformProductVariant, 'baseID' | 'title' | 'price' | 'compareAtPrice'>>
    >;
  };
};

export const PlatformProductDocument = `
    query PlatformProduct($baseID: String!, $platform: Platform!) {
  platformProduct(baseID: $baseID, platform: $platform) {
    ...PlatformProductSelect
    variants {
      ...PlatformProductVariantSelect
    }
  }
}
    ${PlatformProductSelectFragmentDoc}
${PlatformProductVariantSelectFragmentDoc}`;

export const usePlatformProductQuery = <TData = PlatformProductQueryResponse, TError = unknown>(
  variables: PlatformProductQueryVariables,
  options?: UseQueryOptions<PlatformProductQueryResponse, TError, TData>,
) => {
  return useQuery<PlatformProductQueryResponse, TError, TData>(
    ['PlatformProduct', variables],
    appFetcher<PlatformProductQueryResponse, PlatformProductQueryVariables>(
      PlatformProductDocument,
      variables,
    ),
    options,
  );
};

usePlatformProductQuery.getKey = (variables: PlatformProductQueryVariables) => [
  'PlatformProduct',
  variables,
];
